// Textos compartidos por varias zonas (botones genéricos, el selector de idioma,
// los errores de red de api.js). Prefijo "common.".
const en = {
  'common.lang.label': 'Language',
  'common.lang.switchTo': 'Cambiar a español',
  'common.close': 'Close',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.loading': 'Loading…',
  'common.error.generic': 'Something went wrong. Please try again.',
  'common.error.network': 'Could not reach the server. Check your connection.',
};

const es = {
  'common.lang.label': 'Idioma',
  'common.lang.switchTo': 'Switch to English',
  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.delete': 'Borrar',
  'common.loading': 'Cargando…',
  'common.error.generic': 'Algo salió mal. Vuelve a intentarlo.',
  'common.error.network': 'No se pudo conectar con el servidor. Revisa tu conexión.',
};

const locale = { en, es };

export default locale;
